import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Analytics.module.css";
import { getMostPopularpoll } from "../../redux/actions/report.action";

import ReportForm from "./reportForm";
import { ShowResult } from "./showResult";





const Analytics = () => {
  const dispatch = useDispatch();
  const highestData = useSelector(
    (state) => state?.reporting_dashboardReducer?.highest_poll
  );
  const [showResult, setShowResult] = useState(false);

  useEffect(() => {
    dispatch(getMostPopularpoll());
  }, []);

  const data = [
    {
      id: 1,
      name: " Top campaign ",
      value:
        highestData?.campaign_name === "Vouchers"
          ? "Plutos ONE"
          : highestData?.campaign_name ?? "0",
    },
    {
      id: 2,
      name: "Top category",
      value: highestData?.category_name ?? "0",
    },
    {
      id: 5,
      name: "Question",
      value: highestData?.question ?? "0",
    },
    {
      id: 4,
      name: "Highest response on a poll",
      value: highestData?.highest_response ?? "0",
    },
  ];

  const icons = ["HiMiniUserGroup", "MdScreenShare", "FaCalendarDays", ""];

  return (
    <div className={styles.Analytics}>
      {/* **********************Widgets********************** */}
      <div className={styles.widgets}>
        {Array.isArray(data) ? (
          data?.map((ele) => (
            <div className={styles.widget} key={ele?.id}>
              <h5>{ele?.value}</h5>
              <p> {ele?.name} </p>
            </div>
          ))
        ) : (
          <>no data</>
        )}
      </div>

      <div>
        {!showResult ? (
       <ReportForm showResult={showResult} setShowResult={setShowResult}/>
        ) : (

   <ShowResult showResult={showResult} setShowResult={setShowResult}/>
        )}
      </div>
    </div>
  );
};

export default Analytics;
